import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import type { PrivateClassTrackServer } from '../interfaces/private-class-track';
import type { PrivateClassTrackCategoryServer } from '../interfaces/private-class-track-category';
import { hostsConfig } from '../utils';

export default abstract class PrivateClassTrackDao {
  static async getSelectedPrivateClassTrack(
    env: Environment,
    contactId: string
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<PrivateClassTrackServer>(
      `${url}/v1/liveclasslesson-tracks/select`,
      { params: { contactId } }
    );
    return data;
  }

  static async selectPrivateClassTrack(
    env: Environment,
    contactId: string,
    lessonTrackUuid: string
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.post<void>(
      `${url}/v1/liveclasslesson-tracks/select`,
      { contactId, lessonTrackUuid }
    );
    return data;
  }

  static async getPrivateClassTrackCategories(env: Environment) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<PrivateClassTrackCategoryServer[]>(
      `${url}/v1/lesson-track-categories`
    );
    return data;
  }

  static async getPrivateClassTrackByCategory(
    env: Environment,
    contactId: string,
    categoryUUID: string
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<PrivateClassTrackServer[]>(
      `${url}/v1/liveclasslesson-tracks`,
      { params: { contactId, categoryUUID } }
    );
    return data;
  }
}
